export default "__VITE_ASSET__IhvgpX0Q__"